export function isTooLight(hexColor) {
  const [red, green, blue] = hexColor.match(/\w\w/g).map((x) => parseInt(x, 16));

  const highlySensitivePoo = Math.sqrt(
    0.299 * (red * red) + 0.587 * (green * green) + 0.114 * (blue * blue),
  );

  return highlySensitivePoo > 127.5;
}
